export default "__VITE_ASSET__449c4258__"